import { POSTS_PAGE } from '~/constants';

const prepare = Object.freeze({
  users: user => ({
    link: `/war-room/profile/${user.slug}`,
  }),
  communities: community => ({
    link: `/war-room/topics/${community.name}`,
  }),
  content: content => ({
    link: `${POSTS_PAGE.path}/${content.post_slug}`,
    comments: (content.highlight_comments || []).map(comment => ({
      ...comment,
      text: comment.comment_body,
    })),
  }),
});

const geoUsers = list => list.reduce((acct, item) => [...acct, ...item.users], []);

export const prepareData = (data, perPage = 5) => {
  const prepared = {
    ...data,
    users: [...(data.users || []), ...geoUsers(data.geo2users || [])],
    communities: (data.communities || []).filter(c => c.purpose || c.highlight.length),
  };
  return ['users', 'content', 'communities'].reduce((acct, field) => {
    const items = prepared[field] || [];
    const total = Math.ceil(items.length / perPage);
    return {
      ...acct,
      [field]: {
        data: items.map(d => ({
          ...d,
          ...prepare[field](d),
        })),
        page: 0,
        total,
        hasMore: total > 1,
      },
    };
  }, {});
};
